var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIndicatorIcon = function SvgIndicatorIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10.406.649A2 2 0 0 1 11.88 0H21a2 2 0 0 1 2 2v20a2 2 0 0 1-2 2h-9.12a2 2 0 0 1-1.475-.649l-9.166-10a2 2 0 0 1 0-2.702z"
  })));
};
export default SvgIndicatorIcon;